/**
 * Human-readable label for a personalized summary's filing_type tag.
 *
 * Background: the backend's `effective_filing_type` joins every storage
 * folder the engine pulled from with underscores (e.g.
 * "COMMENT_EXPRESS-COMMENT_NPRM" when the user opts in a mis-classified
 * NPRM filing). That's correct as a cache discriminator but ugly as a
 * user-facing tag. This helper collapses it to what the attorney
 * cares about: comment period or reply comment period.
 */

export function formatFilingTypeLabel(
  filingType?: string | null,
  periodType?: string | null
): string | null {
  // period_type is the most reliable signal — use it when present.
  if (periodType === 'reply_comments') return 'Reply Comments';
  if (periodType === 'comments') return 'Comments';

  if (!filingType) return null;

  const upper = filingType.toUpperCase();
  if (upper.includes('REPLY_COMM') || upper.startsWith('REPLY')) {
    return 'Reply Comments';
  }
  if (upper.includes('COMMENT')) {
    return 'Comments';
  }

  // Last resort: titlecase the raw value.
  return filingType
    .replace(/_/g, ' ')
    .replace(/-/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
